<template>
<div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <h2>Sales Quotes</h2>
        <!-- "Add New Quote" Button aligned to the right -->
        <router-link to="/add-quote" class="btn btn-primary">Add New Quote</router-link>
    </div>

    <!-- Loading Image -->
    <div v-if="loading" class="d-flex justify-content-center my-4">
        <img src="@/assets/loading.gif" alt="Loading..." class="loading-image" />
    </div>

    <!-- Quote List -->
    <ul v-if="quotes.length && !loading" class="list-unstyled">
        <li v-for="quote in quotes" :key="quote.id" class="card mb-4 quote-item">
            <router-link :to="`/add-quote?quoteid=${quote.id}`" class="text-decoration-none text-dark">
                <div class="card-body">
                    <h3 class="card-title">{{ quote.customername }}</h3>
                    <p class="card-text">
                        <strong>Last Modified :</strong> {{ quote.qlastmoddate }}
                    </p>
                    <p class="card-text">
                        <strong>Submitted to BC :</strong> {{ quote.submitted }}
                    </p>
                </div>
            </router-link>

            <!-- Delete Icon -->
            <div class="card-footer text-right">
                <button class="btn btn-danger btn-sm" @click="deleteQuote(quote.id)" aria-label="Delete quote" :disabled="quote.submitted">
                    <!-- Font Awesome Trash Icon -->
                    <i class="fas fa-trash-alt"></i>
                </button>
            </div>
        </li>
    </ul>
</div>
</template>

<script>
import {
    logout
} from "@/helper/utils1"; // Use `@` for the src directory
import {
    getQuotesFromCareDB,
    delQuoteFromCareDB
} from "@/helper/RestCalls";
export default {
    data() {
        return {
            quotes: [],
            loading: true,
        };
    },
    async mounted() {
        this.getQuotes();
    },
    methods: {
        async deleteQuote(quoteid) {
            try {
                this.loading = true;
                await delQuoteFromCareDB(quoteid);
                this.quotes = this.quotes.filter(item => item.id !== quoteid);
            } catch (err) {
                console.log(err);
                if (err.status == 401) {
                    logout(this.$router);
                }
            } finally {
                // Hide loading image once data is fetched
                this.loading = false;
            }
        },
        async getQuotes() {
            try {
                this.loading = true;
                this.quotes = await getQuotesFromCareDB();
                console.log(this.quotes);
            } catch (err) {
                console.log(err);
                if (err.status == 401) {
                    logout(this.$router);
                }
            } finally {
                // Hide loading image once data is fetched
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.loading-image {
    width: 50px;
    height: 50px;
}

/* Hover effect */
.quote-item:hover {
    background-color: #d8e2ec;
    /* Light gray on hover */
    cursor: pointer;
}

/* Active state when clicked */
.quote-item.active {
    background-color: #d8e2ec;
    /* Light gray on hover */
    color: white;
    /* White text color */
}

.quote-item.active .card-body {
    border: 2px solid white;
    /* Optional: Add a border for a clearer active state */
}
</style>
